import React from 'react';
import '../../../styles/Celjaink.css';
import '../../../styles/Global.css';
import BackButton from '../../../components/BackButtonPage';


function Celjaink() {

    return (
        <>
            <div className='page-content-container'>
                <p>
                    Az  Egy hajóban…  munkaprogram egy, a történelmi hajózás tematikájára épülő, értékközvetítő 
                    kezdeményezés,  amelynek célja a benne résztvevők  és az iránta érdeklődők 
                    ismeretanyagának bővítése,  valamint olyan szemléletformáló közösségi  élmények biztosítása, 
                    ahol közvetlen,  pozitív tapasztalat  az összmagyarsághoz tartozás,  a közös 
                    történelmi és néprajzi gyökerek megélése és a cselekvő közösségben  gondolkodás.
                </p>
                <p>
                    A közbeszédben általánosan történelmi hagyományőrzésnek nevezett műfajból itthon
                    jelenleg  teljes  mértékben hiányzik  az élővizekhez kötődó  csónakos-hajós  tradíciók 
                    megjelenítésének köre.  Míg más területek (így pl. a lovas hagyományőrzés, az íjászat, 
                    a kézművesség, a vívás, a zenei és táncos hagyományátörökítés, stb…) az elmúlt három
                    évtizedben nagy népszerűségre tettek szert és kialakult a helyük az ismeretterjesztésben,
                    valamint a szabadidőprogramok terén,  addig a folyóvizeinkhez  és tavainkhoz kötődő 
                    történelmi és néprajzi, hajós és egyéb tradíciók fájdalmasan alulreprezentáltak.
                    Ennek az űrnek a megtöltéséhez szeretnénk egy modelladó szándékú kezdeményezéssel 
                    hozzájárulni.
                </p>
                <p>
                    Kiváló apropót szolgátat az a különleges helyzet, hogy aktív részesei lehetünk a Mohácsi
                    csata 500. és a Nándorfehérvári diadal 570. évfordulóját megélő generációnak. E kivételes 
                    lehetőség (egyúttal felelősség!) okán kötelességünknek  tartjuk,  hogy  az  emlékévet 
                    NEMZETI ÜGYKÉNT kezeljük  és minden tudásunkat,  tehetségeink  egész  tárházát  a 
                    méltó megemlékezés szolgálatába állítsuk. Ünnepeljük a diadalt és az egykori csatavesztés 
                    kapcsán  pedig  tisztelegjünk  együtt az önfeláldozó hősiesség egyedülállóan erős jelképe előtt!
                    A két történelmi eseményben közös a hajós vonatkozás. Hunyadit győzelemre segítette, hogy 
                    a magyar dereglyések elpusztították a náluk összehasonlíthatatlanul nagyobb török flottát, 
                    II. Lajost pedig naszádokból álló hajóhad kísérte az oszmán birodalom elleni hősies, ámde 
                    végzetes csatájába. 
                    Ezen okokból a 2026-ig tartó időszakban az Egy hajóban.. projektet elsősorban a fenti két 
                    jubíleumhoz kapcsolódó programelemek és felkészülő-felkészítő munkák határozzák meg.
                </p>
                <p>
                    A 2026-os esztendő, történelmünk drámai fordulópontjainak megjelenítésén, a tisztelgő 
                    főhajtáson és az ismeretterjesztő megemlékezésen túl, lehetőséget ad a nemzeti összetartozás 
                    és társadalmi összefogás egészen különleges demonstrációjára is. 
                    Egy országos sőt, határon túli nemzetrészeink bevonásával teljes Kárpát-medencei volumenű 
                    programsorozatot kezdeményezünk, amelyben Hunyadi dereglyései és a Mohácsi csatába 
                    vonuló királyi had hajóflottájának megjelenítése  mentén foglalkozunk  a történelmi,  a 
                    hadtörténeti és a néprajzi hagyományaink átörökítésével.
                </p>
                <p>
                    Mint mondtuk, sajnos napjainkban a történelmi és néprajzi hagyományőrzés műfajából teljesen 
                    hiányzik a vizekhez, a hajózáshoz kötődő tradícióink megjelenítése, pedig a magyar 
                    műveltségnek olyan alapvető része ez, hogy még nyelvi szinten is megjelenik az összefogás, 
                    az együvé tartozás, az egy cél felé tartás jelölésére a hajószimbólum. Úgy fogalmazunk 
                    ilyenkor, hogy „Egy hajóban evezünk” 
                    Hitünk szerint, ha e témakör mentén demonstratív módon összefog tudós és laikus, civilek, 
                    szakemberek, diákcsoportok, cserkészek, anyaországi vármegyéinket és határontúli nemzetrészeinket 
                    képviselő hagyományőrzők százai, akkor magától értetődően megjelenik a csoda. 
                    Megélhetjük Nándorfehérvár dicsőségét és megérthetjük  Mohács fájdalmas hősiességét is.
                    A fentiekben leírtak arra sarkallnak minket, hogy egy példaadó szándékú projektet indítsunk. 
                    Korabeli hajókat építve, történelmi hajós programokat tartva, résztvevők százait  hívjuk 
                    közös tevékenységre. Azután az emlékév elmúltával megmarad a történelmi regatta, évről 
                    évre eszközt kínálva a nemzeti identitás erősítésére, az összefogás megélésére, akár egy országos 
                    horderejű mozgalomként lehetőséget teremtve számos hajós vonatkozású történelmi
                    esemény lebonyolításához.
                </p>
                <p>
                    Szeretnénk a projekt látványos,  izgalmas kulturális program jellegén túl  aktívan hozzájárulni 
                    az emlékezetpedagógia  ügyének  erősítéséhez,  naprakésszé,  testközelivé  tételéhez. 
                    Példaadó szándékkal, mozgalomindító módon kívánunk közös társadalmi szerepvállalásra 
                    lehetőséget  teremteni a Magyar Honvédség,  az emlékhelyek,  önkormányzatok,  intézmények,  
                    szakemberek  és  civilek,  anyaországi  és  a  határon  túli  magyar  hagyományőrző 
                    csoportok,  diákok, cserkészegyesületek,  tudományos és társadalmi szervezetek széleskörű 
                    együttműködését generálva. 
                </p>


                <div className="centered-image">
                    <img src="/assets/hajo.png" alt="hajo" />
                </div>
                <BackButton to="/projekt" />
            </div>
        </>
    );
}

export default Celjaink;
